// controllers/copy_promotion_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let cookies = JSON.parse(decodeURIComponent(App.readCookie("cookies_preferences")))
    let productAnalyticsCookiesAllowed = cookies?.product_analytics_cookies || true

    if (productAnalyticsCookiesAllowed) {
      document.addEventListener("copy", this._handleCopy.bind(this))
    }
  }

  disconnect() {
    document.removeEventListener("copy", this._handleCopy.bind(this))
  }

  _handleCopy() {
    const copiedText = (window.getSelection()?.toString() || "").trim()
    const copyCount = parseFloat(App.readCookie("js_cc_token")) || 1

    // Count only if the text is an email address
    if (!copiedText.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i) || copyCount > 3) {
      return
    }

    App.createCookie("js_cc_token", copyCount + 1, 7)

    if (copyCount === 3) {
      this.element.classList.add("is-visible")

      App.analytics.posthog_capture("Campaigns copy promotion shown")
    }
  }
}
